import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BirthRecordForm from '../components/BirthRecordForm';
import api from '../utils/api';

const EditRecordPage = () => {
  const { recordId } = useParams();
  const [currentRecord, setCurrentRecord] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCurrentRecord();
  }, [recordId]);

  const loadCurrentRecord = async () => {
    try {
      setIsLoading(true);
      const response = await api.birthRecords.getBirthRecord(recordId);
      setCurrentRecord(response);
    } catch (error) {
      console.error('Error loading current record:', error);
      setError('Failed to load current record data');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow-xl rounded-lg p-8">
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-2 text-gray-600">Loading record data...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow-xl rounded-lg p-8">
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">
              {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Edit Form */}
        <div className="bg-white shadow-xl rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">
              Edit Birth Record
            </h1>
            <p className="text-gray-600 mt-1">
              Update the birth record information below
            </p>
          </div>
          <div className="p-6">
            <BirthRecordForm 
              mode="edit" 
              recordId={recordId} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRecordPage;
